import { getVideoGallery } from "../Service/Api";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
import React, { useState, useEffect } from "react";

const VideoGallery = () => {
  useEffect(() => {
    document.title = "Video Gallery -  Mary Matha Cmi  Academy";
  }, []);

  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [yearRanges, setYearRanges] = useState([]);

  const getYouTubeEmbedUrl = (url) => {
    try {
      const u = new URL(url);

      // youtu.be/<id>
      if (u.hostname.includes("youtu.be")) {
        const id = u.pathname.replace("/", "");
        return id ? `https://www.youtube.com/embed/${id}` : "";
      }

      // youtube.com/watch?v=<id>
      const v = u.searchParams.get("v");
      if (v) return `https://www.youtube.com/embed/${v}`;

      // already embed
      if (u.pathname.includes("/embed/")) return url;

      return "";
    } catch {
      return "";
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const galleryData = await getVideoGallery();
      setData(galleryData);

      const uniqueYears = Array.from(
        new Set(
          galleryData.flatMap((item) => {
            if (item.date) {
              const year = new Date(item.date).getFullYear();
              return [year];
            }
            return [];
          })
        )
      );

      const uniqueYearRanges = uniqueYears.map((year) => `${year}`);
      uniqueYearRanges.sort((a, b) => b - a);
      setYearRanges(uniqueYearRanges);
    };

    fetchData();
  }, []);

  useEffect(() => {
    let filtered = data;

    if (selectedYear !== "All") {
      filtered = filtered.filter((item) => {
        if (!item.date) return false;
        const year = new Date(item.date).getFullYear();
        return parseInt(selectedYear, 10) === year;
      });
    }

    setFilteredData(filtered);
  }, [selectedYear, data]);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li> Gallery </li>
          <li>Video Gallery </li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="chooseyear">
                <select
                  id="chooseddlYear"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="yearSelection"
                >
                  <option value={"All"}>All</option>
                  {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>

              <div className="clr"></div>

              <div className="row">
                {filterData.length > 0 &&
                  filterData.map((item, index) => {
                    const embedUrl = getYouTubeEmbedUrl(item.videoUrl);

                    return (
                      <div
                        className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch"
                        key={index}
                      >
                        <div className="video-gallery">
                          {item?.attachments?.length === 0 ? (
                            <>
                              <iframe
                                width="100%"
                                height="200"
                                src={embedUrl || item.videoUrl}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                              ></iframe>
                              <div>
                                <h3>{item.title}</h3>
                              </div>
                            </>
                          ) : (
                            <>
                              <Link to={item.videoUrl} target="_blank">
                                <LazyLoad>
                                  {item?.attachments?.length > 0 ? (
                                    <img
                                      src={`https://webapi.entab.info/api/image/${item?.attachments[0]}`}
                                      alt="Gallery"
                                      className="img-fluid"
                                    />
                                  ) : (
                                    <img
                                      src="https://webapi.entab.info/api/image/MMATD/public/Images/demo.jpg"
                                      alt="Gallery Placeholder"
                                      className="img-fluid"
                                    />
                                  )}
                                </LazyLoad>
                                <div>
                                  <h3>{item.title}</h3>
                                </div>
                              </Link>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>
              {/* row */}
            </div>
            {/* col */}
          </div>
          {/* row */}
        </div>
        {/* container */}
      </div>

      <Footer />
    </>
  );
};

export default VideoGallery;
